var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11 0h17.718c.862 0 1.7.138 2.511.425a7.058 7.058 0 013.037 2.15A7.01 7.01 0 0131.913 6c.075.463.087.925.087 1.388v17.287c0 .55-.025 1.113-.137 1.65a7.076 7.076 0 01-1.687 3.338 7.073 7.073 0 01-3.124 2.012 7.509 7.509 0 01-2.237.325c-.337 0-17.755 0-18.018-.012A7.128 7.128 0 013.2 30.8 7.223 7.223 0 01.762 28a7.056 7.056 0 01-.712-3.113V7.113A6.638 6.638 0 01.712 4.05a7.097 7.097 0 012.412-2.813A6.997 6.997 0 016.71.025C6.835 0 6.972 0 7.11 0z",
    fill: "url(#paint0_linear_1912_209)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.99 26.175a4.881 4.881 0 00-.375-.512 5.31 5.31 0 00-1.075-.976 3.289 3.289 0 00-1.687-.575c-.425-.024-.85.05-1.25.2-.4.138-.787.338-1.161.538-.438.225-.875.45-1.337.637-.55.226-1.125.4-1.712.526-.737.137-1.487.187-2.224.174a15.026 15.026 0 01-3.949-.6c-1.124-.337-2.199-.8-3.211-1.387a16.557 16.557 0 01-2.487-1.762 18.173 18.173 0 01-1.774-1.763A19.3 19.3 0 013.674 19.3a5.829 5.829 0 01-.375-.588L0 15.15V7.087C0 3.176 3.161 0 7.072 0h6.31l4.673 4.75c10.546 7.175 7.135 15.087 7.135 15.087s2.999 3.375 1.8 6.338z",
    fill: "url(#paint1_linear_1912_209)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.08 4.75c10.546 7.175 7.135 15.087 7.135 15.087s2.999 3.388 1.787 6.35c0 0-1.237-2.075-3.311-2.075-2 0-3.174 2.076-7.197 2.076-8.96 0-13.195-7.488-13.195-7.488 8.072 5.313 13.582 1.55 13.582 1.55-3.636-2.113-11.37-12.213-11.37-12.213 6.734 5.738 9.646 7.25 9.646 7.25-1.737-1.437-6.61-8.462-6.61-8.462 3.898 3.95 11.645 9.463 11.645 9.463 2.2-6.1-2.111-11.538-2.111-11.538z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1912_209",
    x1: 19.029,
    y1: -1.142,
    x2: 12.981,
    y2: 33.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF3E31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1912_209",
    x1: 16.32,
    y1: 0.517,
    x2: 11.894,
    y2: 25.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E39F3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D33929"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwift);
export default __webpack_public_path__ + "static/media/swift.1f60efa648f33f6301695c500e88c4a9.svg";
export { ForwardRef as ReactComponent };